import { NOT_KNOWN } from './constants';

export function getNotKnownTrackingValue(): typeof NOT_KNOWN {
	return NOT_KNOWN;
}
